export { bankAccountCreateRoute } from './route'
